import * as React from "react"

export default function HelpCircleOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 14.667A6.666 6.666 0 118 1.334a6.666 6.666 0 010 13.333zm0-1.333A5.333 5.333 0 108 2.667a5.333 5.333 0 000 10.667zM7.333 10h1.334v1.334H7.334V10zm1.334-1.097v.43H7.334v-1A.667.667 0 018 7.668a1 1 0 10-.98-1.196l-1.308-.262a2.334 2.334 0 112.955 2.694z"
        fill={props.fill}
      />
    </svg>
  )
}
